import type { FC } from "react";
import { useState } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

import { StyledBannerTrial } from "./styles";
import SuccessBanner from "./SuccessBanner/SuccessBanner";

interface IContactUsUpgradeBannerProps {
    titleKey: string;
    subtitleKey: string;
    buttonTextKey: string;
    onSubmit: () => void;
    withSuccessView?: boolean;
    isSubmitted?: boolean;
}

const ContactUsUpgradeBanner: FC<IContactUsUpgradeBannerProps> = ({
    titleKey,
    subtitleKey,
    buttonTextKey,
    onSubmit,
    isSubmitted = false,
    withSuccessView = true,
}) => {
    const [isSuccessViewVisible, setIsSuccessViewVisible] = useState<boolean>(isSubmitted);

    const handleButtonClick = () => {
        if (withSuccessView) {
            setIsSuccessViewVisible(true);
        }
        onSubmit();
    };

    if (isSuccessViewVisible) {
        return (
            <SuccessBanner
                title={translate("hook_modal.get_feature.success.title")}
                subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
            />
        );
    }
    return (
        <StyledBannerTrial
            title={translate(titleKey)}
            subtitle={translate(subtitleKey)}
            buttonType="trial"
            buttonText={translate(buttonTextKey)}
            buttonIconName="sparkles"
            onButtonClick={handleButtonClick}
            bannerBackground={colorsPalettes.sky["100"]}
        />
    );
};

export default ContactUsUpgradeBanner;
